import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { isUser } from "./utils/roleUtils";

const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decoded.exp > currentTime;
    } catch (err) {
        return false;
    }
};

const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/login" />;
    }

    const userRole = localStorage.getItem("role");
    
    // If no specific roles are required, allow access
    if (allowedRoles.length === 0) {
        return children;
    }

    // Check if user has one of the allowed roles
    if (allowedRoles.includes(userRole)) {
        return children;
    }

    // For normal users, redirect to dashboard
    if (isUser()) {
        return <Navigate to="/dashboard" />;
    }

    // For other users, redirect to dashboard
    return <Navigate to="/dashboard" />;
};

export default RoleBasedRoute; 